import React, { FC } from 'react';

import { ILegend } from '@/models/cdl';

interface IProps {
  legend: ILegend | null | undefined;
}

const Legend: FC<IProps> = ({ legend }) => (
  <div
    className="mr-1 h-[10px] w-[10px] flex-shrink-0 rounded-full border-1 border-gray-70"
    style={{
      backgroundColor: legend?.color || '#000000',
    }}
  />
);

export default Legend;
